module.exports = __webpack_public_path__ + "img/3.873eb82d.jpg";